import api from './index'

//获取文章信息
const queryNews = (params) => api.post('home.news', params);
//公告接口
const queryNotices = (params) => api.post('home.notices', params);
//全部系统公告
const getSysnotices= (params) => api.post('home.sysnotices', params);
//首页公告
const getPopNotice= (params) => api.post('home.popnotice', params);
//获取pc首页
const querypcIndex= (params) => api.post('home.pcindex', params);
//首页推荐优惠活动
const queryactivitys= (params) => api.post('home.activitys', params);
//首页推荐电子游戏
const queryelectrons= (params) => api.post('home.electrons', params);
//首页电子游戏
const queryelectronindex= (params) => api.post('home.electronindex', params);
//首页轮播图
const queryIndexBanners = (params) => api.post('home.banners', params);
//获取广告图
const getAds= (params) => api.post('home.ads', params);
//系统配置信息
const queryConfig = (params) => api.post('home.config', params);
//ping网址列表
const queryNetworks= (params) => api.post('home.networks', params);
//语言列表
const getLangs = (params) => api.post('home.langs', params);
//国家编码和区号
const getAreaCodes = (params) => api.post('home.areacodes', params);
//上传图片
const uploadFile = (params) => api.postMult('home.upload', params);
//搜索关键词
const searchKeywords = (params) => api.post('home.searchkeywords', params);
//获取热搜前10名
const getKeywords = (params) => api.post('home.getkeywords', params);
//通过游戏类型获取游戏列表
const getIndexgame = (params) => api.post('home.getindexgame', params);
//获取电子游戏列表/收藏的游戏
const getElectrons = (params) => api.post('home.electrons', params);
//获取用户等级vip
const getLevels = (params) => api.post('home.getlevels', params);
//获取视频VIP列表
const getSvips = (params) => api.post('home.getsvips', params);
//用户购买影视vip
const buyVip = (params) => api.post('user.buyvip', params);


// 首页推荐/精选视频列表
const queryVideoIndex = (params) => api.post('video.index', params);
// 顶部推荐、最新、短视频列表
const queryVideolists = (params) => api.post('video.lists', params);
// 视频分类
const queryVideocategory = (params) => api.post('video.category', params);
// 视频详情
const queryVideoshow = (params) => api.post('video.show', params);
//获取收藏的视频列表
const collectionVideos = (params) => api.post('video.collectionvideos', params);
//获取视频相关的推荐喜欢
const relatedVideos = (params) => api.post('video.relatedvideos', params);
//收藏视频操作
const collectVideo = (params) => api.post('video.collectvideo', params);
//取消收藏视频
const cancleVideo = (params) => api.post('video.canclevideo', params);

//申请优惠活动
const applyDiscount = (params) => api.post('discount.applydiscount', params);
//优惠详情
const discountInfo = (params) => api.post('discount.discountinfo', params);
//优惠活动列表
const discountGetlist = (params) => api.post('discount.getlist', params);
//优惠分类列表
const discountGettopcat = (params) => api.post('discount.gettopcat', params);

//收藏电子游戏
const collectElec = (params) => api.post('user.collectelec', params);
//取消收藏操作
const cancleElec = (params) => api.post('user.cancleelec', params);
//上传用户头像图片
const upThumb= (params) => api.postMult('user.upthumb', params);
//更新在线时长
const Checkonline = (params) => api.post('user.checkonline', params);
//获取用户信息
const getUserInfo = (params) => api.post('user.userinfo', params);
//修改用户信息
const actUserInfo = (params) => api.post('user.editinfo', params);
//注册接口
const postRegister = (params) => api.post('user.actregister', params);
//登录接口
const postLogin = (params) => api.post('user.actlogin', params);
//发送注册短信验证码
const sendSms = (params) => api.post('user.sendsms', params);
//发送找回短信验证码
const sendFSms = (params) => api.post('user.sendfsms', params);
//退出登录接口
const actLoginout = (params) => api.post('user.loginout', params);
//找回密码
const findPassword = (params) => api.post('user.findpass', params);
//修改用户密码操作
const Editpasswd = (params) => api.post('user.editpasswd', params);
//校验用户安全密码/支付密码
const Checksafepass = (params) => api.post('user.checksafepass', params);
//修改用户安全密码/支付密码
const Editsafepass = (params) => api.post('user.editsafepass', params);
//找回支付密码
const Findpaypass = (params) => api.post('user.findpaypass', params);
//全部消息记录
const getMessagelist = (params) => api.post('user.messagelist', params);
//消息详情信息
const getMsginfo = (params) => api.post('user.getmsginfo', params);
//我的-未读消息数量
const getMessagenot = (params) => api.post('user.messagenot', params);
//我的-数量信息显示
const getmyData = (params) => api.post('user.mydata', params);
//设置APP安全密码开关
const safeStatus = (params) => api.post('user.safestatus', params);

//游戏记录-游戏平台注单今日和昨日
const queryPlatformbetlog = (params) => api.post('user.platformbetlog', params);
//游戏记录-游戏平台统计今日和昨日
const queryPlatformgame = (params) => api.post('user.platformgame', params);
//好友转账，转入和转出记录
const queryTransferlist = (params) => api.post('user.transferlist', params);
//好友转账交易
const queryTransfer = (params) => api.post('user.transfer', params);
//提交提现
const queryWithdraw = (params) => api.post('user.withdraw', params);
//获取用户添加的所有提现账号信息
const queryBanks = (params) => api.post('user.banks', params);
//添加用户提现类型数据
const queryAddbank = (params) => api.post('user.addbank', params);
//获取用户提现类型数据
const queryGetbank = (params) => api.post('user.getbank', params);
//获取提现类型列表
const queryDrawings = (params) => api.post('user.drawings', params);
//提交线下充值
const queryRecharge = (params) => api.post('user.recharge', params);
//提交在线支付
const queryOnlineRecharge= (params) => api.post('user.onlinerecharge', params);
//提交修改用户真实姓名
const queryEditrealname= (params) => api.post('user.editrealname', params);
//获取充值类型
const queryPaytypes = (params) => api.post('user.paytypes', params);
//基于充值类型获取具体的方式的
const queryPayments = (params) => api.post('user.payments', params);
//获取游戏记录列表
const queryGamelist = (params) => api.post('user.gamelist', params);
//游戏种类列表
const queryGametypes = (params) => api.post('user.gametypes', params);
//游戏平台列表
const queryGameplats = (params) => api.post('user.gameplats', params);
//获取交易记录列表
const queryTradelist = (params) => api.post('user.tradelist', params);
//获取交易记录类型
const queryTradetype = (params) => api.post('user.gettradetype', params);
//获取返水列表
const queryRakeback= (params) => api.post('user.getrakeback', params);
//领取返水
const Receiverake= (params) => api.post('user.receiverake', params);
//转账到游戏平台，游戏转账到平台
const Transfergame= (params) => api.post('user.transfergame', params);
//获取游戏余额
const getgamemoney= (params) => api.post('user.getgamemoney', params);
//一键回收游戏余额
const Recovergamemoney= (params) => api.post('user.recovergamemoney', params);
//获取进入游戏的链接
const Entergame= (params) => api.post('user.entergame', params);
//认证手机号
const CheckPhone= (params) => api.post('user.checkphone', params);
//开启关闭自动免转
const AutoMoney= (params) => api.post('user.automoney', params);
//领取晋级礼金
const Receivejinji= (params) => api.post('user.receivejinji', params);

// 代理佣金首页
const RecommendIndex = (params) => api.post('recommend.index', params);
// 领取代理佣金操作
const RecommendSendmoney = (params) => api.post('recommend.sendmoney', params);
// 代理游戏记录-游戏平台注单今日和昨日
const Platformbetlog = (params) => api.post('recommend.platformbetlog', params);
// 代理游戏记录-游戏平台统计今日和昨日
const Platformgame = (params) => api.post('recommend.platformgame', params);
//代理找回会员功能
const Findbelowuser = (params) => api.post('recommend.findbelowuser', params);
// 获取代理的佣金结算列表，不需要分标签
const Commissiondata = (params) => api.post('recommend.commissiondata', params);
//获取代理的平台费用统计
const getplatformfee = (params) => api.post('recommend.getplatformfee', params);
//获取代理前端切换的显示类型
const Programmeshows = (params) => api.post('recommend.programmeshows', params);
// 获取下级的会员列表
const getBelowusers = (params) => api.post('recommend.getbelowusers', params);
// 获取推广素材内容
const getDownload = (params) => api.post('recommend.getdownload', params);
//获取充值提现列表
const getTradelist = (params) => api.post('recommend.tradelist', params);
//我的兑换券列表
const getDhmcodes = (params) => api.post('recommend.codes', params);
//获取充值提现列表
const Receivecode = (params) => api.post('recommend.receivecode', params);
export {
	queryNews,
	queryNotices,
	getSysnotices,
	getPopNotice,
	querypcIndex,
	queryactivitys,
	queryelectrons,
	queryelectronindex,
	queryIndexBanners,
	getAds,
	queryConfig,
	queryNetworks,
	getLangs,
	getAreaCodes,
	searchKeywords,
	getKeywords,
	getIndexgame,
	getElectrons,
	getLevels,
	getSvips,
	buyVip,
	queryVideoIndex,
	queryVideolists,
	queryVideocategory,
	queryVideoshow,
	collectionVideos,
	relatedVideos,
	collectVideo,
	cancleVideo,
	applyDiscount,
	discountInfo,
	discountGetlist,
	discountGettopcat,
	uploadFile,
	upThumb,
	collectElec,
	cancleElec,
	Checkonline,
	getUserInfo,
	actUserInfo,
	postRegister,
	postLogin,
	sendSms,
	sendFSms,
	actLoginout,
	findPassword,
	Editpasswd,
	Checksafepass,
	Editsafepass,
	Findpaypass,
	getMessagelist,
	getMsginfo,
	getMessagenot,
	getmyData,
	safeStatus,
	queryPlatformbetlog,
	queryPlatformgame,
	queryTransferlist,
	queryTransfer,
	queryWithdraw,
	queryBanks,
	queryAddbank,
	queryGetbank,
	queryDrawings,
	queryRecharge,
	queryOnlineRecharge,
	queryEditrealname,
	queryPaytypes,
	queryPayments,
	queryGamelist,
	queryGametypes,
	queryGameplats,
	queryTradelist,
	queryTradetype,
	queryRakeback,
	Receiverake,
	Transfergame,
	getgamemoney,
	Recovergamemoney,
	Entergame,
	CheckPhone,
	AutoMoney,
	Receivejinji,
	RecommendIndex,
	RecommendSendmoney,
	Platformbetlog,
	Platformgame,
	Findbelowuser,
	Commissiondata,
	getplatformfee,
	Programmeshows,
	getBelowusers,
	getDownload,
	getTradelist,
	getDhmcodes,
	Receivecode
}



// WEBPACK FOOTER //
// ./src/api/urls.js